import { render, staticRenderFns } from "./ExportPlatforms.vue?vue&type=template&id=5ab4c9ee&scoped=true"
import script from "./ExportPlatforms.vue?vue&type=script&lang=js"
export * from "./ExportPlatforms.vue?vue&type=script&lang=js"
import style0 from "./ExportPlatforms.vue?vue&type=style&index=0&id=5ab4c9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4c9ee",
  null
  
)

export default component.exports